import styled, {css} from 'styled-components';

import {Divider as BaseDivider, Number as BaseNumber} from '../primitives';
import {mixins} from '../styles';
import {EStackDirection} from '../types';

type TStepProps = {
  disabled?: boolean;
};

export const Step = styled.div<TStepProps>`
  ${mixins.stack({direction: EStackDirection.ROW, justify: 'flex-start', align: 'center'})}
  gap: 6px;
  cursor: pointer;
  white-space: nowrap;
  ${({disabled, theme}) => {
    if (disabled) {
      return css`
        cursor: not-allowed;
        color: ${theme.palette.grey400};
      `;
    }

    return css`
      cursor: pointer;
    `;
  }}
`;

export const Number = styled(BaseNumber)`
  ${({theme: {branding, palette}, isActive}) => css`
    border: 2px solid ${isActive ? branding.content.primary : branding.content.tertiary};
    background-color: ${isActive ? palette.grey900 : palette.grey400};
    color: ${palette.white};
  `}
`;

export const CompletedStep = styled(BaseNumber)`
  ${({theme: {branding, palette}, disabled, isActive}) => css`
    border: 2px solid ${disabled ? branding.colors.disabled : branding.content.primary};
    background-color: ${isActive ? palette.grey900 : branding.backgrounds.primary};
    color: ${isActive ? palette.white : branding.content.primary};
  `}
`;

export const Divider = styled(BaseDivider)`
  min-width: 8px;
`;
